import { render, staticRenderFns } from "./reisen-edit-view.vue?vue&type=template&id=92f27870"
import script from "./reisen-edit-view.vue?vue&type=script&lang=js"
export * from "./reisen-edit-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports